//react
import { useEffect, useState } from "react";
import { IntlProvider, LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";

//kendo
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";

//service
import { getOccurEvtList } from "../../../service/monitor/monitorDashboardService";

//css
import "./monitorDashboard.css";

//component
import { BeatLoader } from "react-spinners";
import { useHistory } from "react-router-dom";

const EventGrid = ({ item, conn, dongList, dongCode }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [occurEvtList, setOccurEvtList] = useState([]);
  const [dataState, setDataState] = useState({
    take: 4,
    skip: 0,
    dongCode: dongCode,
  });

  let elements = document.getElementsByClassName("k-pager-sm");
  useEffect(() => {
    //그리드 페이징 가려지는거 처리
    if (elements.length) if (elements[0].classList.value.includes("k-pager-sm")) elements[0].classList.remove("k-pager-sm");
  }, [elements.length]);

  //grid 지역 cell
  const dongCell = e => {
    const { dataItem } = e;
    // const result = '';
    const result = dongList.find(item => item.dongCode === dataItem.dongCode);
    return <td>{result ? result.dongTermSimple : null}</td>;
  };

  const eventTypeTermCell = e => {
    const { dataItem } = e;
    return <td>{dataItem.eventTypeTerm ? dataItem.eventTypeTerm : "-"}</td>;
  };
  //그리드 조회 이벤트
  const getGridData = () => {
    setLoading(true);
    getOccurEvtList(conn, dataState)
      .then(response => {
        setOccurEvtList(response);
        setLoading(false);
      })
      .catch(error => console.log(error));
  };

  // 그리드 페이징 처리
  const handlePageChange = e => {
    const { take, skip } = e.page;
    dataState.skip = skip;
    dataState.take = take;
    getGridData();
  };

  const rowClickEvt = e => {
    const { dataItem } = e;
    const dongCode = dataItem.dongCode;
    const dongTermSimple = dataItem.dongTerm;
    const elderId = dataItem.userId;
    const elderTerm = dataItem.elderTerm;
    const startDtm = new Date(dataItem.ocurDtm);
    const endDtm = new Date(dataItem.ocurDtm);
    const eventType = dataItem.eventType;
    const eventTypeTerm = dataItem.eventTypeTerm;

    history.push({
      pathname: "/log/alert",
      state: { dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, eventType, eventTypeTerm },
    });
  };

  useEffect(() => {
    dataState.dongCode = dongCode;
    dataState.skip = 0;
    getGridData();
  }, [dongCode]);
  return (
    <>
      <table className="MapRightSubTitle" style={{ borderBottom: "none" }}>
        <tr>
          <th>
            <span>발생 이벤트</span>
          </th>
          <td></td>
        </tr>
      </table>
      <div className="dashboardEventGridDiv">
        <LocalizationProvider language="ko-KR">
          <IntlProvider locale="ko">
            <Grid
              className="dashboardEventGrid"
              data={occurEvtList.results}
              style={
                loading
                  ? {
                      height: "100%",
                      opacity: 0.6,
                      pointerEvents: "none",
                    }
                  : { height: "100%", cursor: "pointer" }
              }
              pageable={{ buttonCount: 3, info: true }}
              skip={dataState.skip}
              take={dataState.take}
              total={occurEvtList.total}
              onPageChange={handlePageChange}
              onRowClick={rowClickEvt}>
              <GridColumn title="발생일시" field="ocurDtm" width="180px" />
              <GridColumn title="성함" field="elderTerm" />
              <GridColumn title="지역" field="dongCode" cell={dongCell} />
              <GridColumn title="발생 이벤트" field="eventTypeTerm" cell={eventTypeTermCell} />
              <GridNoRecords>데이터가 존재하지 않습니다.</GridNoRecords>
            </Grid>
          </IntlProvider>
        </LocalizationProvider>
        {loading && (
          <p
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }}>
            <BeatLoader loading={true} size={24} color="#1e88e5" />
          </p>
        )}
      </div>
    </>
  );
};

export default EventGrid;
